import React from 'react';

// Styles
import './BaDetailsListWrapper.scss';

type Props = {
  title: string;
  list: Array<string>;
};

const BaDetailsListWrapper = ({ title, list }: Props) => {
  const baseClassName = 'BaDetailsListWrapper';

  return (
    <div className={baseClassName}>
      <p className={`${baseClassName}__title`}>{title}</p>
      <ul className={`${baseClassName}__list`}>
        {list.map(item => (
          <li key={`${title.replace(/\s/g, '')}--${item.replace(/\s/g, '')}`}>{item}</li>
        ))}
      </ul>
    </div>
  );
};

export default BaDetailsListWrapper;
